import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { SourceOfWealthArray } from "../../Resource/Contents";
import { SectionHeader } from "../SharedComponents";
import { FullClientDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { CountryCodeMap } from "../../../../../../Shared/Entities/Maps/CountryCodeMap";
import { CountryCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CountryCode";
import { SourceOfWealthType } from "../../../../../../../Wrap/Models/Models/Payments/SourceOfWealthType";
import { Action } from "../../../../../Actions/Action";

interface ISourceOfWealthProps extends IProcessComponentProps {
    data: FullClientDetailModel;
    onCCMChange: (changes) => void;
    disableTax: boolean;
}

interface ISourceOfWealthState {
    sourceOfWealthTypes: SourceOfWealthType[];
}

export class SourceOfWealth extends ProcessComponent<ISourceOfWealthProps, ISourceOfWealthState> {
    constructor(props: ISourceOfWealthProps) {
        super(props);
        this.state = {
            sourceOfWealthTypes:[]
        };
    }

    componentDidMount() {
        Action.getSourceOfWealthTypesModel((result) => {
            this.setState({ sourceOfWealthTypes: result.SourceOfWealthTypes })
        });
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
    }

    render() {
        const { data, disableTax } = this.props;
        return (
            <>
                {SectionHeader("Source Of Wealth")}
                {this.state.sourceOfWealthTypes.length > 0 &&
                <SelectEditor
                    cssWrapper="control-size-430"
                    placeholder="Please select"
                    options={SourceOfWealthArray}
                    getText={(v) => this.getTextBySoWId(v)}
                    required={"Please select source of wealth (Primary)"}
                    onChange={(v) =>
                        this.props.onCCMChange([
                            { value: v, path: "EmploymentDetails.SourceOfWealthPrimary.SourceOfWealthOption" },
                        ])
                    }
                    label={"Source of Wealth (Primary)"}
                    disabled={disableTax}
                    selected={data.EmploymentDetails?.SourceOfWealthPrimary?.SourceOfWealthOption}
                    tooltip={"Specify the origin of the accumulated funds."}
                />}

                <SelectEditor
                    cssWrapper="control-size-430"
                    placeholder="Please select"
                    options={CountryCodeMap.getArray(CountryCode.GBR)}
                    getText={(v) => CountryCodeMap.getString(v)}
                    required={"Please select country of origin (Primary)"}
                    onChange={(v) => {
                        this.props.onCCMChange([{ value: v, path: "EmploymentDetails.CountryOfOriginPrimary" }]);
                    }}
                    label="Country of Origin (Primary)"
                    disabled={disableTax}
                    selected={data.EmploymentDetails?.CountryOfOriginPrimary}
                />

                {this.state.sourceOfWealthTypes.length > 0 &&
                <SelectEditor
                    cssWrapper="control-size-430"
                    placeholder="Please select"
                    options={SourceOfWealthArray}
                    getText={(v) => this.getTextBySoWId(v)}
                    onChange={(v) =>
                        this.props.onCCMChange([
                            { value: v, path: "EmploymentDetails.SourceOfWealthSecondary.SourceOfWealthOption" },
                        ])
                    }
                    required={data.EmploymentDetails?.CountryOfOriginSecondary
                        ? "Please select source of wealth (Secondary)" : ""}
                    label={"Source of Wealth (Secondary)"}
                    disabled={disableTax}
                    selected={data.EmploymentDetails?.SourceOfWealthSecondary?.SourceOfWealthOption}
                    tooltip={"Specify the origin of the accumulated funds."}
                />}

                <SelectEditor
                    cssWrapper="control-size-430"
                    placeholder="Please select"
                    options={CountryCodeMap.getArray(CountryCode.GBR)}
                    getText={(v) => CountryCodeMap.getString(v)}
                    onChange={(v) => {
                        this.props.onCCMChange([{ value: v, path: "EmploymentDetails.CountryOfOriginSecondary" }]);
                    }}
                    required={data.EmploymentDetails?.SourceOfWealthSecondary?.SourceOfWealthOption
                        ? "Please select country of origin (Secondary)" : ""}
                    label="Country of Origin (Secondary)"
                    disabled={disableTax}
                    selected={data.EmploymentDetails?.CountryOfOriginSecondary}
                />
            </>
        );
    }

    private getTextBySoWId(soWId) {
        return this.state.sourceOfWealthTypes.find(x => x.TypeId == soWId)?.TypeName ?? "";
    };
}
